const BaseComponent = require('common/home/view');
// const ESClient = require('helper/es-client');
const Server = require('helper/server');
const listTpl = Handlebars.templates['common/home/templates/list-item'];

module.exports = class Home extends BaseComponent {
  constructor () {
    super();
    // this.client = new ESClient();
    this.fetchESData();
  }
  /**
   *  今日开标的数据要从es里去获取
   */
  fetchESData () {
    // const currentTime = new Date();
    // const end = currentTime.getTime();
    // const begin = new Date(currentTime.getFullYear(), currentTime.getMonth(), currentTime.getDate()).getTime();
    // this.client.searchAnnoucement({ pageSize: 10, begin, end }).then((resp) => {
    //   const {
    //     hits: { hits }
    //   } = resp;
    //   const formattedData = hits.map(value => ({
    //     title: value._source.title,
    //     path: value._source.url
    //   }));
    //   console.log(formattedData);
    //   $('#bidOpen .list').html(listTpl({ data: formattedData }));
    // });
    // debugger;
    Server.getTodayBid({
      pageSize: 10
    }).then((resp) => {
      // debugger;
      const {
        hits: { hits }
      } = resp;
      const formattedData = hits.map(value => ({
        title: value._source.title,
        path: value._source.url
      }));
      // console.log(formattedData);
      $('#bidOpen .list').html(listTpl({ data: formattedData }));
    });
  }
};
